// extracted by mini-css-extract-plugin
export default {"description":"complete_description_rOuwP","mainHeader":"complete_mainHeader_BNDAk","welcomeButton":"complete_welcomeButton_KmAKb"};